import { render, staticRenderFns } from "./accordionItemInner.vue?vue&type=template&id=70f01602&scoped=true&"
import script from "./accordionItemInner.vue?vue&type=script&lang=js&"
export * from "./accordionItemInner.vue?vue&type=script&lang=js&"
import style0 from "./accordionItemInner.vue?vue&type=style&index=0&id=70f01602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f01602",
  null
  
)

export default component.exports